import { CAT,  LANG_V2_SUB, NAR, REC, SUB } from "../../Data/typeDirs";
import { LanguageCategory } from "./languageCategory";
import { CAT_FORM_SCHEMA, getCategoryMongooseSchema } from "./utils";


/*
{
  _id
  _mastercategory: LanguageData
  _lang_v2: parent id
  type: 'mastercategories'

}
*/
export class Subcategory extends LanguageCategory{
  constructor(data){
    super(data)
    // this.changed = false
    this.type = Subcategory.getTypeDir()
    this.childTypes = Subcategory.getChildTypes()

  }

  toOldLangEntry(){
    let {fullNumber, number, content, _name, _id} = this
    return {
      [`!fullNum`]: fullNumber,
      [`!num`]: number,
      _mask:content,
      _name: _name|| _id
    }
  }

  getDisplayText(substituteName = ''){
    return `${this.fullNumber} ${substituteName || this.content}`
  }

  getFormData(){
    return LanguageCategory.getFormData(Subcategory, this)
  }

  static getFormKeys(){
    return ['number', 'fullNumber', 'content']
  }

  static getFormSchema(){
    return CAT_FORM_SCHEMA
  }

  static getTypeDir(){
    return SUB
  }
  
  static getRelType(){
    return LANG_V2_SUB
  }

  getTypeAddress(){
    return LanguageCategory.getTypeAddress(Subcategory)
  }
  static getTypeAddress(){
    return LanguageCategory.getTypeAddress(Subcategory)
  }

  static getChildTypes(){
    return [NAR, REC]
  }

  static getParentKey(){
    return CAT
  }
  static getParentAddress(){
    return super.getParentAddress(Subcategory)
  }

  static getFormColWidths(){
    return {
      number:4,
      fullNumber:4,
      content:4
    }
  }

  static constructFromDBData(data){
    return new Subcategory(super.constructFromDBData(data, Subcategory.getTypeDir()))
    
  }

  static getMongooseSchema(mongoose, Schema ){
    return super.getMongooseSchema(
      mongoose, 
      Schema, 
      getCategoryMongooseSchema(mongoose, Subcategory), 
      Subcategory.getTypeDir()
    )
  }

  
}